module.exports = __webpack_public_path__ + "assets/1c57b3481f295105588972ffa1305521.js";